document.addEventListener("DOMContentLoaded", () => {
    // Shared code for "four-column-list-block" and "mosaic-with-hover-text" modules

    var carousels = $("[data-owl]");
    var rtl = document.getElementsByTagName("html")[0].getAttribute("dir") === "rtl" ? true : false;
    const videosPlayClass = 'videos-are-playing';

    //We need this to make the dot buttons accessible
    function addDotButtonText() {
        // loop through each dot element
        $('.owl-dot').each(function () {
            // remove old text nodes
            let span = $(this).find('span');

            span.empty();

            // grab its (zero-based) order in the series
            let idx = $(this).index() + 1;

            if($(this).hasClass('active') && $(this).hasClass('has-video')) {
                // append a span to the button containing descriptive text
                span.text("Toggle video and autoplay");
            } else {
                // append a span to the button containing descriptive text
                span.text("Go to slide " + idx);                
            }
        });
    }

    //Add play/pause buttons for dots if videos are present in the carousel
    function addPlayPauseButtonForVideos(event) {
        const carousel = event.currentTarget;
        const slides = carousel?.querySelectorAll('.owl-item:not(.cloned)');
        const videos = carousel?.querySelectorAll('video');
        const dots = carousel?.querySelectorAll('.owl-dot');
        
        if(slides.length > 0) {
            carousel.classList.add(videosPlayClass);

            slides.forEach((element, index) => {
                const hasVideo = element.querySelector('[data-has-video]')?.getAttribute('data-has-video');

                if(hasVideo !== 'none') {
                    dots[index].classList.add('has-video', 'video-' + hasVideo);
                }
            });

            dots.forEach((element) => {
                element.addEventListener('click', (item) => {
                    const dot = item.currentTarget;

                    if(dot.classList.contains('active')) {
                        if(carousel.classList.contains(videosPlayClass)) {
                            carousel.classList.remove(videosPlayClass);

                            videos.forEach((video) => {
                                video.pause();
                            });
                        } else {
                            carousel.classList.add(videosPlayClass);
                            $(carousel).trigger('next.owl.carousel');

                            videos.forEach((video) => {
                                video.play();
                            });                            
                        }
                    }                    
                });
            });
        }
    }

    function markOwlWrappersAsNone(target) {
        target.querySelector('.owl-stage-outer')?.setAttribute('role', 'none');
        target.querySelector('.owl-stage')?.setAttribute('role', 'none');
        target.querySelectorAll('.owl-item').forEach(function(item) {
            item.setAttribute('role', 'none');
        });
    }

    var carouselSettings = {
        touchDrag: true,
        mouseDrag: true,
        loop: false,
        margin: 0,
        stagePadding: 35,
        nav: false,
        rtl: rtl,
        onInitialized: function (event) {
            addDotButtonText();
            markOwlWrappersAsNone(event.target);
        },
        onResized: function (event) {
            addDotButtonText();
        },
        onChanged: function(event) {
            // Change stagePadding when reaching last slide
            const carousel = event.relatedTarget;
            const currentIndex = carousel.relative(carousel.current());
            const lastIndex = carousel.items().length - 1;

            if (currentIndex === lastIndex) {
                carousel.$element[0].querySelector('.owl-stage')?.classList.add('last');
            } else {
                carousel.$element[0].querySelector('.owl-stage')?.classList.remove('last');
            }
        },        
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 2
            }
        }
    };

    var sliderIsInitialized = false;

    function initialize() {
        if (window.matchMedia("(min-width: 768px)").matches) {
            // destroy owl-carousel and remove all depending classes if window screensize is bigger then 767px
            carousels.trigger('destroy.owl.carousel').removeClass('owl-carousel owl-loaded');
            carousels.find('.owl-stage-outer').children().unwrap();
            //console.log("Destroyed: ", carousels.length);
            sliderIsInitialized = false;
        } else {
            // initialize owl-carousel if window screensize is less the 767px
            if (!sliderIsInitialized) {
                //console.log("Slider is not initialized yet, so do it now!");
                carousels.owlCarousel(carouselSettings);
                carousels.addClass("owl-carousel");
                sliderIsInitialized = true;
            } else {
                //console.log("Slider is already initialized");
            }
        }
    }

    if (carousels.length > 0) {
        initialize();

        $(window).resize(function () {
            initialize();
        });
    }

    var nextSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="24" viewBox="0 0 14 24" aria-hidden="true" focusable="false"><path fill="#000" d="M.293 22.293c-.391.391-.391 1.024 0 1.414s1.024.391 1.414 0L13.414 12 1.707.293C1.316-.098.683-.098.293.293s-.391 1.024 0 1.414L10.586 12 .293 22.293z"/></svg>';
    var prevSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="24" viewBox="0 0 14 24" aria-hidden="true" focusable="false"><path fill="#000" d="M13.7 1.7c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0L.6 12l11.7 11.7c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4L3.4 12 13.7 1.7z"/></svg>';

    function addSvgFilesToPrevAndNextButtons(event) {
        if (event.type === "initialized") {
            $(event.target).find(".owl-nav .owl-prev").removeAttr('role').attr('aria-label', 'Previous').append(prevSvg).find('span').remove();
            $(event.target).find(".owl-nav .owl-next").removeAttr('role').attr('aria-label', 'Next').append(nextSvg).find('span').remove();

            //Move nav button for A11y
            const navNext = $(event.target).find(".owl-nav").addClass('owl-nav--next');
            const navPrev = navNext.clone();
            const prevBtn = $(event.target).find(".owl-nav .owl-prev");

            navPrev.empty().addClass('owl-nav--prev').append(prevBtn);
            $(event.target).prepend(navPrev);
        }
    }

    // Code for "two-column-gallery-block"
    function twoColumnGalleryPagingCallback(event) {
        var carousel = event.relatedTarget;

        if (event.type === "initialized") {
            var pager = `<div class="paging">${carousel.relative(carousel.current()) + 1}/${carousel.items().length}</div>`;

            $(event.target).append(pager);
            addSvgFilesToPrevAndNextButtons(event);
        } else {
            $(event.target).find(".paging").text(`${carousel.relative(carousel.current()) + 1}/${carousel.items().length}`);
        }
    }

    const twoColumnGallery = $("[data-owl-two-column-gallery]");

    if (twoColumnGallery.length > 0) {
        twoColumnGallery.owlCarousel({
            loop: true,
            margin: 0,
            nav: false,
            dots: true,
            items: 1,
            lazyLoad: true,
            lazyLoadEager: 1,
            animateOut: 'fadeOut',
            rtl: false,
            onInitialized: function (event) {
                twoColumnGalleryPagingCallback(event);
                addDotButtonText();
            },
            onChanged: twoColumnGalleryPagingCallback,
            onResized: function (event) {
                addDotButtonText();
            },
            responsive: {
                0: {
                    items: 1
                },
                600: {
                    items: 2,
                    nav: true,
                    dots: false
                }
            }
        });
    }

    // Code for "four-column-gallery-block"
    const fourColumnGallery = $("[data-owl-four-column-gallery]");

    if (fourColumnGallery.length > 0) {
        fourColumnGallery.owlCarousel({
            loop: true,
            margin: 16,
            nav: true,
            dots: false,
            items: 1,
            lazyLoad: true,
            lazyLoadEager: 1,
            rtl: rtl,
            autoHeight: true,
            onInitialized: function (event) {
                addSvgFilesToPrevAndNextButtons(event);
                addDotButtonText();
            },
            onResized: function (event) {
                addDotButtonText();
            },
            responsive: {
                360: {
                    items: 2,
                    nav: false,
                    dots: true
                },
                600: {
                    items: 3,
                    nav: false,
                    dots: true
                },
                1000: {
                    items: 4,
                    nav: false,
                    dots: true
                },
                1200: {
                    items: 4,
                    nav: true,
                    dots: true
                }
            }
        });
    }

    const reviewWithQuote = $("[data-owl-review-with-quote]");

    if (reviewWithQuote.length > 0) {
        reviewWithQuote.owlCarousel({
            loop: true,
            margin: 0,
            nav: false,
            dots: true,
            items: 1,
            autoHeight: true,
            rtl: rtl,
            onInitialized: function (event) {
                addSvgFilesToPrevAndNextButtons(event);
                addDotButtonText();
            },
            onResized: function (event) {
                addDotButtonText();
            },
            responsive: {
                1100: {
                    nav: true
                }
            }
        });
    }

    // Code for "Gallery-With_Text"
    const galleryWithText = $("[data-owl-gallery-with-text]");

    function toggleTruncate(event) {
        event.preventDefault();

        const readMoreButton = $(event.target);
        const json = readMoreButton.data("dictionary");
        const container = readMoreButton.parents(".gallery-with-text");


        if (container.hasClass("is-truncated")) {
            readMoreButton.children().first().text(json.showLessText);
            container.removeClass("is-truncated");
            history.pushState("", document.title, window.location.pathname + window.location.search);
        } else {
            window.location.hash = "#" + container.attr("id");
            setTimeout(function () {
                readMoreButton.children().first().text(json.showMoreText);
                container.addClass("is-truncated");
                history.pushState("", document.title, window.location.pathname + window.location.search);
            }, 350);
        }
    }

    function truncateGalleryContent(evt) {
        const el = evt.relatedTarget.$element;
        const parent = evt.relatedTarget.$element.parent();
        const text = parent.find(".gallery-with-text__content--inner");
        const stage = el.find(".owl-stage-outer");
        const showMoreButton = parent.find(".button.read-more");
        const json = showMoreButton.data("dictionary");

        if (evt.type === "initialized") {
            showMoreButton.children().first().text(json.showMoreText);
            showMoreButton.on("click", toggleTruncate);

            if (text.height() > stage.height()) {
                text.height(stage.height());
                parent.addClass('can-truncate');
                parent.addClass('is-truncated');
            }
        }
    }

    if (galleryWithText.length > 0) {
        //Notice that initialize.owl.carousel and initialized.owl.carousel events must be attached before Owl Carousel initialization.
        //This is required only for those two.
        //Source: https://owlcarousel2.github.io/OwlCarousel2/demos/events.html
        galleryWithText.on('initialized.owl.carousel', function (event) {
            truncateGalleryContent(event);
        });

        galleryWithText.owlCarousel({
            loop: true,
            margin: 0,
            nav: false,
            dots: true,
            items: 1,
            lazyLoad: true,
            lazyLoadEager: 1,
            rtl: rtl,
            onInitialized: function (event) {
                twoColumnGalleryPagingCallback(event);
                addDotButtonText();
            },
            onChanged: function (event) {
                twoColumnGalleryPagingCallback(event);
            },
            onResized: function (event) {
                addDotButtonText();
            },
            responsive: {
                768: {
                    items: 1,
                    nav: true,
                    dots: false
                }
            }
        });
    }

    // Code for "Ticket Upgrades - Used in TicketPassesList.cshtml"
    const ticketUpgrades = $("[data-owl-ticket-upgrades]");

    if (ticketUpgrades.length > 0) {
        setTimeout(function() {
            ticketUpgrades.owlCarousel({
                loop: false,
                margin: 0,
                nav: false,
                dots: true,
                items: 1,
                autoHeight: true,
                rtl: rtl,
                onInitialized: function (event) {
                    addDotButtonText();

                    // Stop propagation on touchstart and mousedown
                    $(event.target).on('touchstart mousedown', function(e) {
                        e.stopPropagation();
                    });                    
                },
                onResized: function (event) {
                    addDotButtonText();
                }
            });
        }, 1000);
    }

    // Code for "Ticket slider - Used in TicketCategoryBlock.cshtml"
    // <div class="owl-ticket-slider-wrapper"></div>
    const ticketSliders = $("[data-owl-ticket-slider=true]");

    if(ticketSliders.length > 0) {
        ticketSliders.each(function() {
            $(this).owlCarousel({
                loop: false,
                stagePadding: 20,
                margin: 10,
                nav: false,
                dots: true,
                items: 1,
                rtl: rtl,
                responsive: {
                    360: {
                        items: 1,
                        nav: false
                    },
                    600: {
                        items: 2,
                        nav: false
                    },
                    750: {
                        items: 3,
                        nav: false
                    },
                    1440: {
                        stagePadding: 0,
                        items: 4,
                        nav: false
                    },
                    1600: {
                        stagePadding: 0,
                        items: 4,
                        nav: true
                    }
                },
                onInitialized: function (event) {
                    addSvgFilesToPrevAndNextButtons(event);
                    addDotButtonText();
                },
                onResized: function (event) {
                    addDotButtonText();
                },
                onChanged: function(event) {
                    // Change stagePadding when reaching last slide
                    const carousel = event.relatedTarget;
                    const currentIndex = carousel.relative(carousel.current());
                    const lastIndex = carousel.items().length - 1;

                    if (currentIndex === lastIndex) {
                        carousel.$element[0].querySelector('.owl-stage')?.classList.add('last');
                    } else {
                        carousel.$element[0].querySelector('.owl-stage')?.classList.remove('last');
                    }
                },                 
            });
        })
    };

    function syncActiveSlideVariantClass(currentSlide) {
        var isNewVariant = currentSlide.find('.hero-frontpage--mobile-block-below').length > 0;
        $('[data-owl-hero-frontpage]').toggleClass('active-slide-is-new-variant', isNewVariant);
    }

    var p;
    function setHeroFrontpageCarouselDelay(owl) {
        owl.trigger('stop.owl.autoplay');
        var carouselTiming = $('[data-owl-hero-frontpage] .owl-item.active .item').data('delay');

        if (p) {
            clearTimeout(p);
        }

        if (carouselTiming !== 0) {
            p = setTimeout(function () {
                //Switch to next slide if videos are playing
                if(owl[0].classList.contains(videosPlayClass)) {
                    owl.trigger('next.owl.carousel');
                }
            }, carouselTiming);
        }
    }

    const heroFrontPageCarousel = $("[data-owl-hero-frontpage]");
    if (heroFrontPageCarousel.length > 0) {
        
        var initialDelay = parseInt(heroFrontPageCarousel.data("initial-delay"));
        var frontPageOwl = heroFrontPageCarousel.owlCarousel({
            autoplayTimeout: initialDelay,
            autoplay: initialDelay > 0 ? true:false,
            loop: true,
            margin: 0,
            nav: false,
            dots: true,
            items: 1,
            lazyLoad: true,
            lazyLoadEager: 1,
            autoHeight: true,
            rtl: rtl,
            onInitialized: function (event) {
                addSvgFilesToPrevAndNextButtons(event);
                addPlayPauseButtonForVideos(event);
                addDotButtonText();
                let currentSlide = $('[data-owl-hero-frontpage] .owl-item.active .item');
                currentSlide.removeAttr('inert');
                syncActiveSlideVariantClass(currentSlide);
            },
            onResized: function (event) {
                addDotButtonText();
            },
            responsive: {
                1100: {
                    items: 1,
                    nav: true,
                    dots: true
                }
            }
        });

        frontPageOwl.on('initialized.owl.carousel translated.owl.carousel', function (e) {            
            frontPageOwl.trigger('stop.owl.autoplay');
            setHeroFrontpageCarouselDelay(frontPageOwl);
        });

        frontPageOwl.on('translate.owl.carousel', function (e) {
            var currentSlide = $('[data-owl-hero-frontpage] .owl-item.active .item');
            var vidContainer = currentSlide.find(".inline-hero-background");
            var button = currentSlide.find(".hero-video__sound-button");
            var vid = vidContainer.find("video");
            if (vid.length) {
                vid.prop("muted", true);
                button.removeClass("on");
            }
            currentSlide.attr('inert', '');            
        });
        frontPageOwl.on('translated.owl.carousel', function (e) {
            var currentSlide = $('[data-owl-hero-frontpage] .owl-item.active .item');
            currentSlide.removeAttr('inert');
            addDotButtonText();
            syncActiveSlideVariantClass(currentSlide);
        });
    }

    const pixleeCarousel = $("[data-owl-pixlee]");
    if (pixleeCarousel.length > 0) {
        var initialDelay = 0;

        pixleeCarousel.owlCarousel({
            autoplayTimeout: initialDelay,
            autoplay: initialDelay > 0 ? true:false,
            loop: true,
            margin: 0,
            nav: true,
            dots: false,
            items: 1,
            lazyLoad: true,
            lazyLoadEager: 1,
            autoHeight: true,
            rtl: rtl,
            onInitialized: function (event) {
                addSvgFilesToPrevAndNextButtons(event);
            },
        });
    }

    /********************
     * SPLIT HERO CAROUSEL
     **/
    const splitHeroCarousels = $("[data-owl-split-hero]");
    let splitHeroCarouselsIsInitialized = false;

    var splitHeroCarouselSettings = {
        autoplay: false,
        loop: false,
        margin: 0,
        nav: false,
        dots: true,
        items: 1,
        lazyLoad: true,
        lazyLoadEager: 1,
        autoHeight: true,
        rtl: rtl,
        stagePadding: 16,
        onChanged: function(event) {
            // Change stagePadding when reaching last slide
            const carousel = event.relatedTarget;
            const currentIndex = carousel.relative(carousel.current());
            const lastIndex = carousel.items().length - 1;

            if (currentIndex === lastIndex) {
                carousel.$element[0].querySelector('.owl-stage')?.classList.add('last');
            } else {
                carousel.$element[0].querySelector('.owl-stage')?.classList.remove('last');
            }
        },          
    };

    function initializeSplitHeroCarousels() {
        if (window.matchMedia("(min-width: 768px)").matches) {
            // destroy owl-carousel and remove all depending classes if window screensize is bigger then 767px
            splitHeroCarousels.trigger('destroy.owl.carousel').removeClass('owl-carousel owl-loaded');
            splitHeroCarousels.find('.owl-stage-outer').children().unwrap();
            //console.log("Destroyed: ", carousels.length);
            splitHeroCarouselsIsInitialized = false;
        } else {
            // initialize owl-carousel if window screensize is less the 767px
            if (!splitHeroCarouselsIsInitialized) {
                //console.log("Slider is not initialized yet, so do it now!");
                splitHeroCarousels.owlCarousel(splitHeroCarouselSettings);
                splitHeroCarousels.addClass("owl-carousel");
                splitHeroCarouselsIsInitialized = true;
            } else {
                //console.log("Slider is already initialized");
            }
        }
    }

    if (splitHeroCarousels.length > 0) {
        initializeSplitHeroCarousels();

        $(window).resize(function () {
            initializeSplitHeroCarousels();
        });
    }

    /********************
     * DEFAULT TICKETS CAROUSEL
     **/
    const ticketModuleSliders = $("[data-owl-ticket-slider-module]");
    
    ticketModuleSliders.each(function() {
        let ticketModuleSlidersIsInitialized = false;
        const slider = $(this);        

        const sliderSettings = {
            autoplay: false,
            loop: false,
            margin: 10,
            nav: false,
            dots: true,
            items: 1,
            lazyLoad: true,
            lazyLoadEager: 1,
            autoHeight: false,
            rtl: rtl,
            stagePadding: 20,
            onChanged: function(event) {
                // Change stagePadding when reaching last slide
                const carousel = event.relatedTarget;

                if(carousel.items().length > 1) {
                    const currentIndex = carousel.relative(carousel.current());
                    const lastIndex = carousel.items().length - 1;

                    if (currentIndex === lastIndex) {
                        carousel.$element[0].querySelector('.owl-stage')?.classList.add('last');
                    } else {
                        carousel.$element[0].querySelector('.owl-stage')?.classList.remove('last');
                    }
                }
            },          
        };

        // Listen for custom event
        const filteredTicketsCopy = document.querySelector('[data-filtered-tickets="copy"]');

        if (filteredTicketsCopy) {
            filteredTicketsCopy.addEventListener('ticketsUpdated', (event) => {
                // Refresh Owl Carousel
                slider.trigger('destroy.owl.carousel').removeClass('owl-carousel owl-loaded');
                slider.find('.owl-stage-outer').children().unwrap();
                slider.owlCarousel(sliderSettings);
                slider.addClass("owl-carousel");                
            });
        }        

        function initializeTicketModuleCarousels() {
            if (window.matchMedia("(min-width: 768px)").matches) {
                // destroy owl-carousel and remove all depending classes if window screensize is bigger then 767px
                slider.trigger('destroy.owl.carousel').removeClass('owl-carousel owl-loaded');
                slider.find('.owl-stage-outer').children().unwrap();
                //console.log("Destroyed: ", carousels.length);
                ticketModuleSlidersIsInitialized = false;
            } else {
                // initialize owl-carousel if window screensize is less the 767px
                if (!ticketModuleSlidersIsInitialized) {
                    slider.owlCarousel(sliderSettings);
                    slider.addClass("owl-carousel");
                    ticketModuleSlidersIsInitialized = true;
                } else {
                    //console.log("Slider is already initialized");
                }
            }
        }

        initializeTicketModuleCarousels();

        $(window).resize(function () {
            initializeTicketModuleCarousels();
        });
    });
});